import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    logToAnalyticsQuickStakeButtonsClick,
    findAnalytics,
} from '../../../../../../App/analyticsTracking';

const STAKES = [1, 2, 5, 10];
const analytics = findAnalytics();

class QuickStake extends Component {

    constructor(props) {
        super(props);
        this.stakeButtons = STAKES.map(stake => ({
            stake,
            increase: this.increaseStake.bind(this, stake),
        }));
    }

    increaseStake(amount) {
        const {
            value,
            setStake,
            onStakeUpdated,
            maxLength,
            isMobile,
            outcomersId,
            currencySign,
            bookmakerName,
            betslipID,
            horseName,
            fractionalPrice,
            raceId,
            courseName,
            raceTime,
            raceDate,
        } = this.props;

        const stake = `${currencySign}${amount}`;
        const floatValue = parseFloat(value) || 0;
        const increasedValue = floatValue + amount;
        const newValue = isMobile ? String(increasedValue) : (increasedValue).toFixed(2);

        if (newValue.length <= maxLength) {
            setStake(outcomersId, newValue);
            onStakeUpdated(newValue);
            if (analytics) {
                logToAnalyticsQuickStakeButtonsClick(
                    bookmakerName,
                    betslipID,
                    horseName,
                    fractionalPrice,
                    stake,
                    raceId,
                    courseName,
                    raceTime,
                    raceDate,
                    analytics,
                );
            }
        }
    }

    render() {
        const { currencySign } = this.props;
        return (
            <div className="bs-form__group bs-betForm__quickStake">
                {
                    this.stakeButtons.map(({ stake, increase }) => (
                        <button
                            type="button"
                            key={stake}
                            className="bs-betForm__quickStakeItem"
                            onClick={increase}
                        >
                            <span>{`+${currencySign}${stake}`}</span>
                        </button>
                    ))
                }
            </div>
        );
    }
}

QuickStake.defaultProps = {
    isMobile: false,
    bookmakerName: null,
    betslipID: null,
    horseName: null,
    fractionalPrice: null,
    raceId: null,
    courseName: null,
    raceTime: null,
    raceDate: null,
}

QuickStake.propTypes = {
    currencySign: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    setStake: PropTypes.func.isRequired,
    onStakeUpdated: PropTypes.func.isRequired,
    maxLength: PropTypes.number.isRequired,
    isMobile: PropTypes.bool,
    outcomersId: PropTypes.string.isRequired,
    bookmakerName: PropTypes.string,
    betslipID: PropTypes.string,
    horseName: PropTypes.string,
    fractionalPrice: PropTypes.string,
    raceId: PropTypes.string,
    courseName: PropTypes.string,
    raceTime: PropTypes.string,
    raceDate: PropTypes.string,
}

export default QuickStake;



// WEBPACK FOOTER //
// /src/js/drawer/components/BetPage/components/BetForm/components/QuickStake.jsx